const actionType = {
    GET_SUMMARY_CHAPTER: "GET_SUMMARY_CHAPTER",
    GET_SUMMARY_CHAPTER_SUCCESS: "GET_SUMMARY_CHAPTER_SUCCESS",
    GET_SUMMARY_CHAPTER_FAILURE: "GET_SUMMARY_CHAPTER_FAILURE"
};

export default actionType;